import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=439e578c&"
import script from "./PersonalSettings.vue?vue&type=script&lang=js&"
export * from "./PersonalSettings.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports